import { defineMessages } from 'react-intl';

export default defineMessages({
  selectInputPlaceholder: {
    id: 'neptune.PhoneNumberInput.SelectInput.placeholder',
    defaultMessage: 'Select an option...',
  },
  countryCodeLabel: {
    id: 'neptune.PhoneNumberInput.countryCodeLabel',
    defaultMessage: 'Country code',
  },
  phoneNumberLabel: {
    id: 'neptune.PhoneNumberInput.phoneNumberLabel',
    defaultMessage: 'Phone number',
  },
});
